import { useId, useRef, useState } from 'react';
import { useRoving } from './useRoving';
import { createEvent } from '../utilities/createEvent';
import mergeRefs from 'react-merge-refs';

export const useDrawer = (props) => {
  const { onClose } = props;

  const [isOpen, setIsOpen] = useState(false);

  const openDrawer = () => setIsOpen(true);
  const closeDrawer = () => {
    setIsOpen(false);
    createEvent(onClose);
  };

  const id = useId();
  const listId = 'drawer-list' + id;
  const triggerId = 'drawer-trigger' + id;

  // Handle roving keyboard focus accessibility

  const listRef = useRef();

  useRoving(listRef);

  const exitProps = (ref, props) => {
    const { onClick, ...rest } = props;

    const onClickHandler = () => {
      createEvent(onClose);
      createEvent(onClick);
      closeDrawer();
    };

    const kbd = {
      onClick: onClickHandler,
    };

    const rps = {
      role: 'menuitem',
      'aria-label': 'Close drawer',
    };

    const rct = {
      ref,
    };

    return {
      ...kbd,
      ...rps,
      ...rct,
      ...rest,
    };
  };

  const linkProps = (ref, props) => {
    const { dontCloseOnClick, dontRunOnClose, onClick, ...rest } = props;

    const onClickHandler = () => {
      createEvent(onClick);

      if (dontRunOnClose) {
        setIsOpen(false);
      } else {
        !dontCloseOnClick && closeDrawer();
      }
    };

    const kbd = {
      onClick: onClickHandler,
    };

    const rps = {
      role: 'menuitem',
    };

    const rct = {
      ref,
      tabIndex: -1,
    };

    return {
      ...kbd,
      ...rps,
      ...rct,
      ...rest,
    };
  };

  const listProps = (ref, props) => {
    const kbd = {
      onMouseDown: (e) => e.stopPropagation(), // prevent close on mouse down
    };

    const rps = {
      id: listId,
      role: 'menu',
      'aria-labelledby': triggerId,
    };

    const rct = {
      ref: mergeRefs([listRef, ref]),
    };

    return {
      ...kbd,
      ...rps,
      ...rct,
      ...props,
    };
  };

  const triggerProps = (ref, props) => {
    const { onClick, ...rest } = props;

    const onClickHandler = () => {
      createEvent(onClick);
      openDrawer();
    };

    const kbd = {
      onClick: onClickHandler,
    };

    const rps = {
      id: triggerId,
      'aria-haspopup': true,
      'aria-expanded': isOpen,
      'aria-controls': isOpen ? listId : null,
    };

    const rct = {
      ref,
    };

    return {
      ...kbd,
      ...rps,
      ...rct,
      ...rest,
    };
  };

  return {
    isOpen,
    setIsOpen,
    closeDrawer, // used by Layer component
    exitProps,
    linkProps,
    listProps,
    triggerProps,
  };
};
